import { StringInputViewModel, ValueFormField } from '@sitecore-jss/sitecore-jss-forms';
import { ValueFieldProps, Label, FieldChangeCallback } from '@sitecore-jss/sitecore-jss-react-forms';
import { FC, Fragment } from 'react';

import { FieldValidationErrors } from '../CustomFields/FieldValidationErrors';
import { getFormFieldAriaProps } from '../Functions/FormFieldAriaProps';

/**
 * Overrides the built-in Sitecore forms telephone.
 * @see [Original Telephone Implementation](https://github.com/Sitecore/jss/blob/v22.10.0/packages/sitecore-jss-react-forms/src/components/field-templates/telephone.tsx)
 *
 * Markup and functionality should be 1:1 with the exception of `getFormFieldAriaProps`.
 *
 * @param props - Telephone properties.
 * @returns A telephone field.
 */
export const BaseTelephone: FC<ValueFieldProps<StringInputViewModel>> = (props) => {
  const { errors, field, onChange, tracker, value } = props;

  return (
    <Fragment>
      <Label {...props} />
      <input
        type="tel"
        className={field.model.cssClass}
        id={field.valueField.id}
        name={field.valueField.name}
        value={value}
        maxLength={field.model.maxLength}
        placeholder={field.model.placeholderText}
        onChange={(e) => handleOnChange(field, e.target.value, onChange)}
        onFocus={() => tracker.onFocusField(field, value)}
        onBlur={() => tracker.onBlurField(field, value, errors)}
        {...getFormFieldAriaProps(field, errors)}
      />
      <FieldValidationErrors {...props} />
    </Fragment>
  );
};

function handleOnChange(field: ValueFormField, fieldValue: string, callback: FieldChangeCallback) {
  const errorMessages = [];
  let valid = true;

  if (field.model.required && !fieldValue) {
    errorMessages.push(`${field.model.title} is required`);
    valid = false;
  }

  callback(field.valueField.name, fieldValue, valid, errorMessages);
}
